import cx from 'classnames'
import { MdWarningAmber } from 'react-icons/md'

import styles from './error-banner.module.css'

interface Props {
  title: string
  subTitle?: string
  color?: 'red' | 'orange'
  onRetry?: () => void
  isRetrying?: boolean
}

export function ErrorBanner ({ title, subTitle, color = 'orange', onRetry, isRetrying }: Props): JSX.Element {
  return (
    <div className={cx(styles.warningWrapper, styles[color])}>
      <div className={styles.icon}>
        <MdWarningAmber
          size='1.4rem'
          color={color === 'red' ? '#D04437' : '#E4980F'}
        />
      </div>
      <div className={styles.info}>
        <div className={styles.title}>{title}</div>

        {subTitle && (
          <div className={styles.subTitle}>
            {subTitle}
          </div>
        )}
      </div>

      {typeof onRetry === 'function' && (
        <button
          type='button'
          className={styles.retry}
          onClick={() => {
            onRetry()
          }}
          disabled={isRetrying}
        >
          {isRetrying ? 'Retrying...' : 'Retry'}
        </button>
      )}
    </div>
  )
}
